import { render, staticRenderFns } from "./SdsTableSection1ProductInfo.vue?vue&type=template&id=77fa7043"
import script from "./SdsTableSection1ProductInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsTableSection1ProductInfo.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports